import { Component, OnInit, Input } from '@angular/core';
import { ReservationService } from '../../../service/reservation.service';
import { Reservation } from '../../../model/reservation.model';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ChangeStatusDialogComponent } from '../../change-status-dialog/change-status-dialog.component';
import { AuthService } from 'src/app/service/auth.service';
import { DialogService } from 'src/app/service/dialog.service';
import { DatePipe } from '@angular/common';
import { BooleanPipe } from 'src/app/pipes/boolean-pipe';
import { TranslationPipe } from 'src/app/pipes/translation.pipe';
import { PaymentService } from 'src/app/service/payment.service';
import { MatRadioChange } from '@angular/material';

@Component({
  selector: 'app-reservation-list',
  templateUrl: './reservation-list.component.html',
  styleUrls: ['./reservation-list.component.css']
})
export class ReservationListComponent implements OnInit {
  reservationTableColumns: any[];
  reservations: Reservation[];
  selectedRadioButton : number;
  @Input() isLessonReservation : number;

  constructor(
    private reservationService: ReservationService,
    private router: Router,
    public dialog: MatDialog,
    public authService: AuthService,
    private dialogService: DialogService,
    private datePipe: DatePipe,
    private booleanPipe: BooleanPipe,
    private paymentService: PaymentService,
    private translationPipe: TranslationPipe,
    private activedRoute: ActivatedRoute
  ) {

    if (typeof this.isLessonReservation==='undefined' && this.router.getCurrentNavigation().extras.state) {
      this.isLessonReservation = this.router.getCurrentNavigation().extras.state.isLessonReservation as number;
    }
  }

  ngOnInit() {
    if(this.isLessonReservation==1 || typeof this.isLessonReservation==='undefined') {
      this.selectedRadioButton=0;
      this.refreshData(1);
     
    }else{
      this.selectedRadioButton=1;
      this.refreshData(0);
      
    }
    this.initReservationsTable();
  }

  initReservationsTable() {
    this.reservationTableColumns = [
      { field: 'id', header: 'lblResListID' },
      { field: 'user', header: 'lblResListUser' },
      { field: 'dateFrom', header: 'lblResListFrom' },
      { field: 'dateTo', header: 'lblResListTo' },
      { field: 'status', header: 'lblResListStatus' },
      { field: 'dateCreated', header: 'lblResListDateCreated' },
      { field: 'amount', header: 'lblResListAmount' },
      { field: 'amountPayed', header: 'lblResListPayed' },
      { field: 'paymentId', header: 'lblResListPaymentId' },
    ]
  }

  get reservationTableData() {
    if (this.reservations) {
      return this.reservations.map(r => ({
        id: r.id,
        user: r.user ? (r.user.name + (r.user.name !== r.user.lastName ? r.user.lastName : '')) : '',
        dateFrom: r.dateFrom,
        dateTo: r.dateTo,
        status: this.translationPipe.transform(r.status.description),
        dateCreated: r.dateCreated,
        amount: r.amount,
        amountPayed: r.amountPayed,
        paymentId: r.paymentId,
      }));
    } else {
      return [];
    }
  }

  refreshData(isLessonReservation) {
    this.reservations= [];
    if (this.authService.currentUserIsAdmin) {
      this.reservationService
        .GetAll(isLessonReservation)
        .subscribe(data => {
          this.reservations = data as Reservation[];
        });
    } else {
      this.reservationService
        .GetByUserId(this.authService.currentUserValue.id, isLessonReservation)
        .subscribe(data => (this.reservations = data as Reservation[]));
    }
  }


  editStatus(rowElement) {

    const element = this.reservations.find(r => r.id === rowElement.id);
    if (this.authService.currentUserIsAdmin) {
      const dialogRef = this.dialog.open(ChangeStatusDialogComponent, {
        width: '300px',
        data: {
          title: `Change reservation status`,
          status: element.status,
          reservation: element
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result=='da') {
         /*  this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigateByUrl('/reservation-list'); */
          this.refreshData(1)
        }
        else if(result=='ne'){
          this.refreshData(0)
        }
      });
    }
  }

  view(element) {
    this.router.navigateByUrl('/reservation-process/' + element.id, { state: { reservationListOrEquipment: 'reservationList' } });
  }

  pay(element) {
    this.reservationService.getByIdWithOrderItems(element.id).subscribe(res => {
      this.router.navigateByUrl('/payment-init', { state: { reservation: res, reservationList: 'reservationList' }  });
      });
  }

  paymentDetail(element) {
    this.router.navigateByUrl('/payment-finish/' + element.paymentId);
  }

  onChangeLessonReservationEquipmentRental(mrChange: MatRadioChange) {
    if (mrChange.value == 0) {
      this.refreshData(1);
      this.selectedRadioButton=0;
    }
    if (mrChange.value == 1) {
      this.refreshData(0);
      this.selectedRadioButton=1;
    }
  }
}
